import { useQuery } from '@tanstack/react-query'
import { authApi } from 'shared/api/auth'
import { AUTH_PERMISSIONS } from 'shared/api/auth/constants'
import { useCheckPermission } from 'shared/api/auth/hooks/useCheckPermission'

interface GetQrCodeResponse {
  qr: string
  secret: string
}

const getQrCode = async () => {
  const response = await authApi.get<GetQrCodeResponse>('/2fa/qrcode')

  return response.data
}

export const useGetQrCode = (enabled: boolean = true) => {
  const hasPermission = useCheckPermission(AUTH_PERMISSIONS.readUser) || true

  const query = useQuery({
    queryKey: ['qrCode'],
    queryFn: () => getQrCode(),
    enabled: hasPermission && enabled,
    staleTime: 0,
    refetchOnWindowFocus: false
  })

  return { query, hasPermission }
}
